import { Button, Collapse, Form, Image, Input, Slider, Spin, Tabs } from "antd";
import { CollectionServer, CollectionByProperty, Field, formItemRules, getDisplay, getLocator, getObjectValue, JSX, JSXMap, Model, QueryDetail, QueryFiltersToContextFilters, QueryOrder, uncapitalize, useAuth, useFormObserverContext, useMetaContext } from "fennec-ui";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { getRandomColor } from "../../../../common/Tool";
import dayjs from "dayjs";
import uuid from "react-uuid";
var _ = require('lodash');



CanvasRenderingContext2D.prototype.roundRect = function (x, y, w, h, r) {
    if (w < 2 * r) r = w / 2;
    if (h < 2 * r) r = h / 2;
    this.beginPath();
    this.moveTo(x + r, y);
    this.arcTo(x + w, y, x + w, y + h, r);
    this.arcTo(x + w, y + h, x, y + h, r);
    this.arcTo(x, y + h, x, y, r);
    this.arcTo(x, y, x + w, y, r);
    this.closePath();
    return this;
}

const AudioContext = window.AudioContext || window.webkitAudioContext;
const audioContext = new AudioContext();

export default function AudioProperties(props) {
    const { response, object, links } = props;
    const auth = useAuth();

    const [duration, setDuration] = React.useState();
    const [currentTime, setCurrentTime] = React.useState(0);
    const audioRef = useRef();
    const [audioBuffer, setAudioBuffer] = useState();
    const [resapledBuffer, setResapledBuffer] = useState();
    const [startEnd, setStartEnd] = useState([0, 0])
    const [loading, setLoading] = useState(false)
    const [temp, setTemp] = useState()

    const str_pad_left = (string, pad, length) => {
        return (new Array(length + 1).join(pad) + string).slice(-length);
    }
    const onLoadedMetadata = () => {
        if (audioRef.current && data?.arrayBuffer) {
            audioRef.current.volume = 60 / 100;
            const sec = audioRef.current.duration;
            const minutes = Math.floor(sec / 60);
            const seconds = Math.floor(sec - minutes * 60);
            const time = str_pad_left(minutes, '0', 2) + ':' + str_pad_left(seconds, '0', 2);
            if (setDuration) {
                setDuration({ time, sec })
            }
            if (props?.form) {
                props.form.setFieldsValue({
                    obshchayaDlitelnost: Math.floor(sec),
                    dataRazmeshcheniya: dayjs().format('YYYY-MM-DD')
                })
            }

            (async function audioView() {
                var buffer = await audioContext.decodeAudioData(data?.arrayBuffer);
                var bufResampleSize = 16000;
                buffer = downsampleAudioBuffer(buffer, bufResampleSize)
                setAudioBuffer(buffer);
            })()

        }
    };

    useEffect(() => {
        if (duration?.sec) {
            setStartEnd([0, Math.floor(duration?.sec)]);
        }
    }, [duration])

    useEffect(() => {
        if (audioBuffer) {
            intiCanvasData(audioBuffer);
        }
    }, [audioBuffer])

    // useEffect(() => {
    //     if (resapledBuffer) {
    //         displayBuffer(resapledBuffer, audioBuffer.duration, startEnd, currentTime);
    //     }
    // }, [resapledBuffer, startEnd, currentTime])

    const setCurrentTimeThrottle = React.useCallback(_.throttle(setCurrentTime, 200, { 'trailing': false }), []);
    const timeUpdate = (event) => {
        const minutes = Math.floor(event.target.currentTime / 60);
        const seconds = Math.floor(event.target.currentTime - minutes * 60);
        const currentTime = str_pad_left(minutes, '0', 2) + ':' + str_pad_left(seconds, '0', 2);
        setCurrentTimeThrottle(event.target.currentTime);
        // setCurrentTime(event.target.currentTime);
    }

    const refCanvas = useRef(null)
    const [data, setData] = useState();
    const [essentia, setEssentia] = useState();

    useEffect(() => {
        response?.then(resp => {
            setData(resp);

            import(
                /* webpackChunkName: "my-chunk-name" */
                /* webpackExports: ["default", "named"] */
                'essentia.js')
                .then((esPkg) => {
                    const ess = new esPkg.Essentia(esPkg.EssentiaWASM.EssentiaWASM);
                    setEssentia(ess)
                }).catch(err => {
                    console.error("Ошибка загрузки essentia.js", err)
                });
        })
    }, [])

    function downsampleAudioBuffer(buf, rate) {
        var channels = buf.numberOfChannels;
        var sampleRate = buf.sampleRate

        if (rate == sampleRate) {
            return buf;
        }
        if (rate > sampleRate) {
            throw "downsampling rate show be smaller than original sample rate";
        }

        var sampleRateRatio = sampleRate / rate;
        var newLength = Math.round(buf?.getChannelData(0)?.length / sampleRateRatio);
        var toBuffer = audioContext.createBuffer(channels, newLength, rate);

        for (var i = 0; i < channels; i++) {
            var buffer = buf.getChannelData(i);
            var toChanData = toBuffer.getChannelData(i);

            var offsetResult = 0;
            var offsetBuffer = 0;

            while (offsetResult < toChanData.length) {
                var nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
                // Use average value of skipped samples
                var accum = 0, count = 0;
                for (var i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
                    accum += buffer[i];
                    count++;
                }
                toChanData[offsetResult] = accum / count;
                // Or you can simply get rid of the skipped samples:
                // result[offsetResult] = buffer[nextOffsetBuffer];
                offsetResult++;
                offsetBuffer = nextOffsetBuffer;
            }
        }
        return toBuffer;
    }

    function copyBuffer(fromBuffer, fromStart, fromEnd, toStart) {

        var sampleRate = fromBuffer.sampleRate;

        var frameCount = fromBuffer.length;
        if (fromEnd && fromEnd > 0) {

            var frameCount = (fromEnd - fromStart) * sampleRate;
            if (frameCount > fromBuffer.length) {
                frameCount = fromBuffer.length
            }
        }


        var channels = fromBuffer.numberOfChannels;
        var toBuffer = audioContext.createBuffer(channels, frameCount, sampleRate);

        for (var i = 0; i < fromBuffer.numberOfChannels; i++) {
            var fromChanData = fromBuffer.getChannelData(i);
            var toChanData = toBuffer.getChannelData(i);
            for (var j = 0, f = Math.round(fromStart * sampleRate), t = Math.round(toStart * sampleRate); j < frameCount; j++, f++, t++) {
                toChanData[t] = fromChanData[f];
            }
        }
        return toBuffer
    }

    function intiCanvasData(buff) {
        let canvasWidth = refCanvas.current?.parentElement?.clientWidth || refCanvas.current.width;
        let canvasHeight = refCanvas.current?.parentElement?.clientHeight || refCanvas.current.height;
        refCanvas.current.width = canvasWidth;
        refCanvas.current.height = canvasHeight;

        var leftChannel = buff.getChannelData(0); // Float32Array describing left channel       
        // we 'resample' with cumul, count, variance
        // Offset 0 : PositiveCumul  1: PositiveCount  2: PositiveVariance
        //        3 : NegativeCumul  4: NegativeCount  5: NegativeVariance
        // that makes 6 data per bucket
        var resampled = new Float64Array(canvasWidth * 6);
        var i = 0, j = 0, buckIndex = 0;
        var min = 1e3, max = -1e3;
        var thisValue = 0, res = 0;
        var sampleCount = leftChannel.length;
        var stepFramePercent = 0
        var step = parseInt(sampleCount / canvasWidth / 100 * stepFramePercent) || 1

        // first pass for mean
        for (i = 0; i < sampleCount; i += step) {
            // in which bucket do we fall ?
            buckIndex = 0 | (canvasWidth * i / sampleCount);
            buckIndex *= 6;
            // positive or negative ?
            thisValue = leftChannel[i];
            if (thisValue > 0) {
                resampled[buckIndex] += thisValue;
                resampled[buckIndex + 1] += 1;
            } else if (thisValue < 0) {
                resampled[buckIndex + 3] += thisValue;
                resampled[buckIndex + 4] += 1;
            }
            if (thisValue < min) min = thisValue;
            if (thisValue > max) max = thisValue;
        }
        // compute mean now
        for (i = 0, j = 0; i < canvasWidth; i++, j += 6) {
            if (resampled[j + 1] != 0) {
                resampled[j] /= resampled[j + 1];;
            }
            if (resampled[j + 4] != 0) {
                resampled[j + 3] /= resampled[j + 4];
            }
        }
        // second pass for mean variation  ( variance is too low)
        for (i = 0; i < sampleCount; i += step) {
            // in which bucket do we fall ?
            buckIndex = 0 | (canvasWidth * i / leftChannel.length);
            buckIndex *= 6;
            // positive or negative ?
            thisValue = leftChannel[i];
            if (thisValue > 0) {
                resampled[buckIndex + 2] += Math.abs(resampled[buckIndex] - thisValue);
            } else if (thisValue < 0) {
                resampled[buckIndex + 5] += Math.abs(resampled[buckIndex + 3] - thisValue);
            }
        }
        // compute mean variation/variance now
        for (i = 0, j = 0; i < canvasWidth; i++, j += 6) {
            if (resampled[j + 1]) resampled[j + 2] /= resampled[j + 1];
            if (resampled[j + 4]) resampled[j + 5] /= resampled[j + 4];
        }

        setResapledBuffer(resampled);
    }

    useEffect(() => {
        if (!refCanvas.current) {
            return;
        }
        const context = refCanvas.current.getContext("2d");
        let requestId;
        const render = () => {
            //
            // context.drawImage(images[frameIndex], 0, 0);
            //
            if (resapledBuffer) {
                displayBuffer(context, resapledBuffer, audioBuffer.duration, startEnd, currentTime);
            }
            requestId = requestAnimationFrame(render);
        };
        render();
        return () => cancelAnimationFrame(requestId);
    }, [resapledBuffer, startEnd, currentTime]);

    // useEffect(() => {
    //     let requestId;
    //     const render = () => {
    //         context.beginPath();
    //         context.arc(
    //             canvas.width / 2,
    //             canvas.height / 2,
    //             canvas.width / 2,
    //             0,
    //             2 * Math.PI
    //         );
    //         context.fill();
    //         requestId = requestAnimationFrame(render);
    //     };
    //     render();
    //     return () => {
    //         cancelAnimationFrame(requestId);
    //     };
    // });

    function displayBuffer(context, resampled, duration, startEnd, currentTime) {
        // var context = refCanvas.current.getContext('2d');
        let canvasWidth = refCanvas.current.width;
        let canvasHeight = refCanvas.current.height;

        context.save();
        context.fillStyle = '#FEFEFE';
        context.fillRect(0, 0, canvasWidth, canvasHeight);
        context.translate(0.5, canvasHeight / 2);
        let paddingTopBottom = 10;
        context.scale(1, canvasHeight - (paddingTopBottom * 2));

        for (var i = 0; i < canvasWidth; i++) {
            let j = i * 6;

            context.strokeStyle = '#225cf6';
            // context.strokeStyle = gradient1;
            context.beginPath();
            context.moveTo(i, (resampled[j] - resampled[j + 2]));
            context.lineTo(i, (resampled[j + 3] + resampled[j + 5]));
            context.stroke();
            // draw from positiveAvg - variance to positiveAvg + variance 
            context.strokeStyle = "#91caff";
            context.beginPath();
            context.moveTo(i, (resampled[j] - resampled[j + 2]));
            context.lineTo(i, (resampled[j] + resampled[j + 2]));
            context.stroke();
            // draw from negativeAvg + variance to negativeAvg - variance 
            context.strokeStyle = '#91caff';
            context.beginPath();
            context.moveTo(i, (resampled[j + 3] + resampled[j + 5]));
            context.lineTo(i, (resampled[j + 3] - resampled[j + 5]));
            context.stroke();
        }

        // context.strokeStyle = "#000";
        // context.beginPath();
        // context.moveTo(0, (resampled[3] - resampled[5]));
        // for (var i = 0; i < canvasWidth; i+=1) {
        //     let j = i * 6;

        //     // we 'resample' with cumul, count, variance
        //     // Offset 0 : PositiveCumul  1: PositiveCount  2: PositiveVariance
        //     //        3 : NegativeCumul  4: NegativeCount  5: NegativeVariance

        //     // context.strokeStyle = "#fd7e14";

        //     context.moveTo(i, (resampled[j + 3] + resampled[j + 5]));
        //     context.lineTo(i, (resampled[j + 3] - resampled[j + 5]));

        //     // context.strokeStyle = "#fd7e14";
        //     // context.beginPath();
        //     // context.moveTo(i, 0);
        //     // context.lineTo(i, (resampled[j] + resampled[j + 2]));
        //     // context.stroke();
        // }
        // context.stroke();

        var gradientf = context.createLinearGradient(0, -1, 0, 1);
        gradientf.addColorStop(0, "#91caff");
        gradientf.addColorStop(0.5, "rgba(255,255,255,0.30)");
        gradientf.addColorStop(1, "#91caff");

        var gradient = context.createLinearGradient(0, -1, 0, 1);
        gradient.addColorStop(0, "#71ffff")
        gradient.addColorStop(0.33, "#4dbeff")
        gradient.addColorStop(0.66, "#a66eff")
        gradient.addColorStop(1, "#d425ef")

        var gradientc = context.createLinearGradient(0, -1, 0, 1);
        gradientc.addColorStop(0, "#F00")
        gradientc.addColorStop(0.33, "#a06eff")
        gradientc.addColorStop(0.66, "#d826ff")
        gradientc.addColorStop(1, "#F00")

        if (currentTime) {
            let time = canvasWidth / Math.floor(duration);

            var tcurr = Math.floor(time * currentTime);
            context.strokeStyle = gradientc;
            context.lineWidth = 1;
            context.beginPath();
            context.moveTo(tcurr, -canvasHeight / 2);
            context.lineTo(tcurr, canvasHeight / 2);
            context.stroke();
        }
        if (Math.floor(duration) > 0) {
            let time = canvasWidth / Math.floor(duration);

            var tStart = Math.floor(time * startEnd[0]);
            context.fillStyle = gradientf;//"rgba(100,100,100,0.10)";
            context.fillRect(0, -1, tStart, 2);

            context.strokeStyle = gradient;
            context.lineWidth = 2;
            context.beginPath();
            context.moveTo(tStart, -canvasHeight / 2);
            context.lineTo(tStart, canvasHeight / 2);
            context.stroke();

            var tEnd = Math.floor(time * startEnd[1]);
            context.fillStyle = gradientf;//"rgba(100,100,100,0.10)";
            context.fillRect(tEnd, -1, canvasWidth, 2);

            context.strokeStyle = gradient;
            context.lineWidth = 2;
            context.beginPath();
            context.moveTo(tEnd, -canvasHeight / 2);
            context.lineTo(tEnd, canvasHeight / 2);
            context.stroke();
        }

        context.restore();
    }

    function removeUnprintable(str) {
        if (!hasUnprintable(str)) {
            return str;
        }

        var array = [];
        for (var i = 0; i < str.length; ++i) {
            var charCode = str.charCodeAt(i);
            if (!isUnprintable(charCode)) {
                array.push(charCode);
            } else {
                // console.log(charCode);
            }
        }
        return String.fromCharCode.apply(String, array);
    }

    function hasUnprintable(str) {
        for (var i = 0; i < str.length; ++i) {
            var charCode = str.charCodeAt(i);
            if (isUnprintable(charCode)) {
                return true;
            }
        }
        return false;
    }

    function isUnprintable(charCode) {
        return charCode !== 9 && charCode !== 10 && (charCode < 32 || charCode === 65279);
    }

    useEffect(() => {
        if (data?.tags?.kommentarii && !object?.ID) {
            if (props?.form) {
                props.form.setFieldsValue({
                    kommentarii: removeUnprintable(data?.tags?.kommentarii)
                })
            }
        }
    }, [data?.tags?.kommentarii])
    useEffect(() => {
        if (data?.tags?.godSozdaniya && !object?.ID) {
            if (props?.form) {
                props.form.setFieldsValue({
                    godSozdaniya: data?.tags?.godSozdaniya
                })
            }
        }
    }, [data?.tags?.godSozdaniya])
    useEffect(() => {
        if (data?.tags?.nazvanieTreka && !object?.ID) {
            if (props?.form) {
                props.form.setFieldsValue({
                    nazvanieTreka: data?.tags?.nazvanieTreka
                })
            }
        }
    }, [data?.tags?.nazvanieTreka])

    const bpmAction = useCallback((values, unlock, close, { collection, setCollection, apply }) => {
        setLoading(true);
        setTimeout(
            (async () => {
                if (audioBuffer) {
                    let start = startEnd[0];
                    let end = startEnd[1] || Math.floor(duration?.sec);
                    let buffer = audioBuffer;
                    if (end < start) {
                        end = Math.floor(duration?.sec);
                    }

                    if ((end - start) > 0) {
                        buffer = copyBuffer(audioBuffer, start, end, 0);
                    }

                    const data = buffer?.getChannelData(0)
                    const buf = await essentia.arrayToVector(data);
                    // var key = essentia.KeyExtractor(buf, true, 4096, 4096, 12, 3500, 60, 25, 0.2, 'bgate', buffer.sampleRate, 0.0001, 440, 'cosine', 'hann');
                    var temp = essentia.PercivalBpmEstimator(buf, 1024, 2048, 128, 128, 210, 50, buffer.sampleRate).bpm;

                    setTemp(temp)
                    // if (props?.form) {
                    //     props.form.setFieldsValue({
                    //         temp: Math.floor(temp)
                    //     })
                    // }
                    if (apply) {
                        apply(Math.floor(temp));
                    }
                }
                setLoading(false)
            }), 1000);
    }, [essentia, audioBuffer, duration, startEnd, setTemp]);
    const tempAction = useCallback(() => ([
        {
            title: (<i className="fa fa-calculator"></i>),
            readonly: true,
            noAntForm: true,
            // mode: "func",
            // trigger: (click) => (<Button loading={loading} onClick={click}><i className="fa fa-calculator"></i></Button>),
            triggerOptions: {
                loading: loading || !essentia || !audioBuffer || !duration?.sec
            },
            action: bpmAction,
        },
    ]), [bpmAction, loading]);

    const sozdatelitreka_e = React.useMemo(() => {
        return {
            "name": "SozdateliTrekaTrek",
            "type": "object",
            "label": "Создатели трека",
            "relation": {
                "type": "one-many",
                "reference": {
                    "object": "SozdateliTreka",
                    "property": "Trek"
                },
                uiFilter: () => [],
                displayString: (item) => {
                    return `${item?.tipDlyaTreka?.nazvanie}: ${item?.sozdatel?.familiya} ${item?.sozdatel?.imya}${(item?.sozdatel?.psevdonim) ? " (" + item?.sozdatel?.psevdonim + ")" : ""}`
                },
                display: (item) => {
                    return (
                        <div>
                            <div style={{ fontSize: "12px", color: "rgba(0,0,0,0.65)" }}>{item?.tipDlyaTreka?.nazvanie}</div>
                            <div>{item?.sozdatel?.familiya} {item?.sozdatel?.imya}</div>
                            {/* <div style={{ color: "rgba(0,0,0,0.65)" }}>{item?.sozdatel?.psevdonim}</div> */}
                        </div>
                    )
                }
            },
            "validators": {
                "required": false,
                "min": null,
                "max": null,
                "pattern": null
            },
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("sozdatel.familiya", "ASC"),
            ],
        }
    }, [])

    return (<div>
        {(data?.tags) && <div style={{ paddingBottom: "10px", display: "flex", gap: "10px" }}>
            <div style={{ flex: "0 0 115px" }}>
                <Image
                    style={{
                        borderRadius: "4px",
                        boxShadow: "2px 2px 2px 0px rgba(34, 60, 80, 0.35)"
                    }}
                    width={115}
                    src={data?.tags?.picture}
                    fallback="data:image/png;base64,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"
                />
            </div>
            <div style={{ flex: "1 1 auto" }}>
                {(data?.tags?.filename && !data?.tags?.author && !data?.tags?.title) && <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                    {data?.tags?.filename.replace(/\.[^/.]+$/, "")}
                </div>}

                {data?.tags?.author && <div style={{ fontSize: "16px", fontWeight: "bold" }}>{data?.tags?.author}</div>}
                {data?.tags?.title && <div style={{ fontSize: "16px" }}>{data?.tags?.title}</div>}
                {data?.tags?.album && <div style={{ fontSize: "14px", color: "rgba(0,0,0,.65)" }}>{data?.tags?.album}</div>}
                {data?.tags?.year && <div style={{ fontSize: "14px", color: "rgba(0,0,0,.65)" }}>{data?.tags?.year}</div>}
                {/* {data?.tags?.genre && <div style={{ fontSize: "14px", color: "rgba(0,0,0,.65)" }}>{data?.tags?.genre}</div>} */}
                {data?.tags?.bpm && <div style={{ fontSize: "14px", color: "rgba(0,0,0,.65)" }}>{data?.tags?.bpm}</div>}
            </div>
        </div>}
        <div>
            {(data?.arrayBuffer && data?.url) && <audio id="audio" style={{ width: "100%" }} controls
                ref={audioRef}
                onLoadedMetadata={onLoadedMetadata}
                onTimeUpdate={timeUpdate}>
                <source src={data?.url} type="audio/mpeg" />
            </audio>}
        </div>
        <Spin spinning={loading || !essentia || !audioBuffer || !duration?.sec}>
            <div style={{ height: "100px" }}>
                <canvas ref={refCanvas} style={{ borderRadius: "4px" }}></canvas>
            </div>
        </Spin>
        {(essentia && audioBuffer && duration?.sec) && <div style={{ padding: "5px 0", display: "flex", flexDirection: "column", gap: "5px" }}>
            <Slider
                disabled={loading}
                key="startEnd"
                data-locator="startEnd"
                range
                // defaultValue={def}
                min={0}
                max={Math.floor(duration?.sec) || 0}
                step={0.01}
                value={startEnd}
                included={true}
                onChange={setStartEnd}
                tooltip={{
                    formatter: (sec) => {
                        const minutes = Math.floor(sec / 60);
                        const seconds = Math.floor(sec - minutes * 60);
                        // const mseconds = Math.floor(sec - minutes * 60 - seconds * 60);
                        const time = str_pad_left(minutes, '0', 2) + ':' + str_pad_left(seconds, '0', 2)//+ '.' + str_pad_left(mseconds, '0', 2);
                        return time
                    }
                }}
            />
        </div>}

        <div>
            <Form
                form={props?.form}
                onFinish={props?.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={object}
            >
                {JSX(() => { // Актуальность
                    let data = undefined;
                    let locator = undefined;
                    let isChangedField = undefined;
                    let contextObject = undefined;
                    let funcStat = undefined;
                    let object = undefined;
                    let objectName = props?.name;
                    let item = {
                        "name": "Aktualnost",
                        "type": "bool",
                        "label": "Актуальность",
                        "validators": {
                            "required": false,
                            "min": null,
                            "max": null,
                            "pattern": null
                        },
                    }
                    return (
                        <Form.Item
                            preserve={(item?.hidden) ? "true" : "false"}
                            hidden={item?.hidden}
                            key={item?.name}
                            name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                            label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                            rules={formItemRules(item)}
                            data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                        >
                            <Field
                                // value={value}
                                // onChange={onChange}
                                key={item?.name}
                                objectName={objectName}
                                contextObject={contextObject}
                                auth={auth}
                                formItem={true}
                                data={data}
                                item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                            />
                        </Form.Item>
                    )
                })}
                {JSX(() => { // Название трека
                    let data = undefined;
                    let locator = undefined;
                    let isChangedField = undefined;
                    let contextObject = undefined;
                    let funcStat = undefined;
                    let object = undefined;
                    let objectName = props?.name;
                    let item = {
                        "description": "",
                        "name": "NazvanieTreka",
                        "type": "string",
                        "label": "Название трека",
                        "validators": {
                            "required": true,
                            "min": null,
                            "max": 250,
                            "pattern": null
                        },
                    }
                    return (
                        <Form.Item
                            preserve={(item?.hidden) ? "true" : "false"}
                            hidden={item?.hidden}
                            key={item?.name}
                            name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                            label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                            rules={formItemRules(item)}
                            data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                        >
                            <Field
                                // value={value}
                                // onChange={onChange}
                                key={item?.name}
                                objectName={objectName}
                                contextObject={contextObject}
                                auth={auth}
                                formItem={true}
                                data={data}
                                item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                            />
                        </Form.Item>
                    )
                })}
                <div style={{ display: "flex", gap: "10px" }}>
                    {JSX(() => { // Танец
                        let data = undefined;
                        let locator = undefined;
                        let isChangedField = undefined;
                        let contextObject = undefined;
                        let funcStat = undefined;
                        let object = undefined;
                        let objectName = props?.name;
                        let item = {
                            "name": "Tanets",
                            "type": "object",
                            "label": "Танец",
                            "relation": {
                                "type": "many-one",
                                "reference": {
                                    "object": "Tantsi",
                                    "property": "ID"
                                },
                            },
                            "validators": {
                                "required": true,
                                "min": null,
                                "max": null,
                                "pattern": null
                            },
                        }
                        return (
                            <Form.Item
                                style={{ width: "100%" }}
                                preserve={(item?.hidden) ? "true" : "false"}
                                hidden={item?.hidden}
                                key={item?.name}
                                name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                                label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                                rules={formItemRules(item)}
                                data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                            >
                                <Field
                                    // value={value}
                                    // onChange={onChange}
                                    key={item?.name}
                                    objectName={objectName}
                                    contextObject={contextObject}
                                    auth={auth}
                                    formItem={true}
                                    data={data}
                                    item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                    isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                                />
                            </Form.Item>
                        )
                    })}
                    {JSX(() => { // Направление танца
                        let data = undefined;
                        let locator = undefined;
                        let isChangedField = undefined;
                        let contextObject = undefined;
                        let funcStat = undefined;
                        let object = undefined;
                        let objectName = props?.name;
                        let item = {
                            "name": "NapravlenieTantsa",
                            "type": "object",
                            "label": "Направление танца",
                            "relation": {
                                "type": "many-one",
                                "reference": {
                                    "object": "VidiTantsev",
                                    "property": "ID"
                                },
                            },
                            "validators": {
                                "required": true,
                                "min": null,
                                "max": null,
                                "pattern": null
                            },
                        }
                        return (
                            <Form.Item
                                style={{ width: "100%" }}
                                preserve={(item?.hidden) ? "true" : "false"}
                                hidden={item?.hidden}
                                key={item?.name}
                                name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                                label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                                rules={formItemRules(item)}
                                data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                            >
                                <Field
                                    // value={value}
                                    // onChange={onChange}
                                    key={item?.name}
                                    objectName={objectName}
                                    contextObject={contextObject}
                                    auth={auth}
                                    formItem={true}
                                    data={data}
                                    item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                    isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                                />
                            </Form.Item>
                        )
                    })}
                </div>
                {JSX(() => { // ! Общая длителность *
                    let data = undefined;
                    let locator = undefined;
                    let isChangedField = undefined;
                    let contextObject = undefined;
                    let funcStat = undefined;
                    let object = undefined;
                    let objectName = props?.name;
                    let item = {
                        "hidden": true, //!!!!!!!!!!!!!
                        "name": "ObshchayaDlitelnost",
                        "type": "uint",
                        "label": "Общая длителность",
                        "validators": {
                            "required": false,
                            "min": null,
                            "max": null,
                            "pattern": null
                        },
                    }
                    return (
                        <Form.Item
                            preserve={(item?.hidden) ? "true" : "false"}
                            hidden={item?.hidden}
                            key={item?.name}
                            name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                            label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                            rules={formItemRules(item)}
                            data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                        >
                            <Field
                                // value={value}
                                // onChange={onChange}
                                key={item?.name}
                                objectName={objectName}
                                contextObject={contextObject}
                                auth={auth}
                                formItem={true}
                                data={data}
                                item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                            />
                        </Form.Item>
                    )
                })}
                {JSX(() => { // Дата размещения *
                    let data = undefined;
                    let locator = undefined;
                    let isChangedField = undefined;
                    let contextObject = undefined;
                    let funcStat = undefined;
                    let object = undefined;
                    let objectName = props?.name;
                    let item = {
                        "hidden": true, //!!!!!!!!!!!!!
                        "name": "DataRazmeshcheniya",
                        "comment": "Автоматическая установка time.Now()",
                        "type": "datetime",
                        "label": "Дата размещения",
                        "validators": {
                            "required": false,
                            "min": null,
                            "max": null,
                            "pattern": null
                        },
                    }
                    return (
                        <Form.Item
                            preserve={(item?.hidden) ? "true" : "false"}
                            hidden={item?.hidden}
                            key={item?.name}
                            name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                            label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                            rules={formItemRules(item)}
                            data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                        >
                            <Field
                                // value={value}
                                // onChange={onChange}
                                key={item?.name}
                                objectName={objectName}
                                contextObject={contextObject}
                                auth={auth}
                                formItem={true}
                                data={data}
                                item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                            />
                        </Form.Item>
                    )
                })}
                <div style={{ display: "flex", gap: "10px" }}>
                    {JSX(() => { // Год создания
                        let data = undefined;
                        let locator = undefined;
                        let isChangedField = undefined;
                        let contextObject = undefined;
                        let funcStat = undefined;
                        let object = undefined;
                        let objectName = props?.name;
                        let item = {
                            "name": "GodSozdaniya",
                            "type": "uint",
                            "label": "Год создания",
                            "validators": {
                                "required": false,
                                "min": null,
                                "max": null,
                                "pattern": null
                            },
                        }
                        return (
                            <Form.Item
                                style={{ width: "100%" }}
                                preserve={(item?.hidden) ? "true" : "false"}
                                hidden={item?.hidden}
                                key={item?.name}
                                name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                                label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                                rules={formItemRules(item)}
                                data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                            >
                                <Field
                                    // value={value}
                                    // onChange={onChange}
                                    key={item?.name}
                                    objectName={objectName}
                                    contextObject={contextObject}
                                    auth={auth}
                                    formItem={true}
                                    data={data}
                                    item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                    isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                                />
                            </Form.Item>
                        )
                    })}
                    {JSX(() => { // ! Темп
                        let data = undefined;
                        let locator = undefined;
                        let isChangedField = undefined;
                        let contextObject = undefined;
                        let funcStat = undefined;
                        let object = undefined;
                        let objectName = props?.name;
                        let item = {
                            "name": "Temp",
                            "type": "uint",
                            "label": "Темп",
                            "validators": {
                                "required": false,
                                "min": null,
                                "max": null,
                                "pattern": null
                            },
                            actions: tempAction,
                            // dropdownActions: () => [
                            //     {
                            //         title: "Рассчитать темп",
                            //         readonly: true,
                            //         noAntForm: true,
                            //         // form: Model,
                            //         // meta: [
                            //         //     {
                            //         //         label: "Фамилия",
                            //         //         name: "familiya",
                            //         //         type: "string",
                            //         //     },
                            //         // ],
                            //         action: bpmAction,
                            //     },
                            // ]
                        }
                        return (
                            <Form.Item
                                style={{ width: "100%" }}
                                preserve={(item?.hidden) ? "true" : "false"}
                                hidden={item?.hidden}
                                key={item?.name}
                                name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                                label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                                rules={formItemRules(item)}
                                data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                            >
                                <Field
                                    // value={value}
                                    // onChange={onChange}
                                    key={item?.name}
                                    objectName={objectName}
                                    contextObject={contextObject}
                                    auth={auth}
                                    formItem={true}
                                    data={data}
                                    item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                    isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                                />
                            </Form.Item>
                        )
                    })}
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                    {JSX(() => { // Длительность вступления сек
                        let data = undefined;
                        let locator = undefined;
                        let isChangedField = undefined;
                        let contextObject = undefined;
                        let funcStat = undefined;
                        let object = undefined;
                        let objectName = props?.name;
                        let item = {
                            "name": "DlitelnostVstupleniyaSek",
                            "type": "uint",
                            "label": "Вступление сек",
                            "validators": {
                                "required": false,
                                "min": null,
                                "max": null,
                                "pattern": null
                            },
                        }
                        return (
                            <Form.Item
                                style={{ width: "100%" }}
                                preserve={(item?.hidden) ? "true" : "false"}
                                hidden={item?.hidden}
                                key={item?.name}
                                name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                                label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                                rules={formItemRules(item)}
                                data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                            >
                                <Field
                                    // value={value}
                                    // onChange={onChange}
                                    key={item?.name}
                                    objectName={objectName}
                                    contextObject={contextObject}
                                    auth={auth}
                                    formItem={true}
                                    data={data}
                                    item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                    isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                                />
                            </Form.Item>
                        )
                    })}
                    {JSX(() => { // Энергетика
                        let data = undefined;
                        let locator = undefined;
                        let isChangedField = undefined;
                        let contextObject = undefined;
                        let funcStat = undefined;
                        let object = undefined;
                        let objectName = props?.name;
                        let item = {
                            "name": "Energetika",
                            "type": "object",
                            "label": "Энергетика",
                            "relation": {
                                "type": "many-one",
                                "reference": {
                                    "object": "Energetika",
                                    "property": "ID"
                                },
                                display: (item) => {
                                    return item?.nazvanie
                                }
                            },
                            "validators": {
                                "required": false,
                                "min": null,
                                "max": null,
                                "pattern": null
                            },
                        }
                        return (
                            <Form.Item
                                style={{ width: "100%" }}
                                preserve={(item?.hidden) ? "true" : "false"}
                                hidden={item?.hidden}
                                key={item?.name}
                                name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                                label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                                rules={formItemRules(item)}
                                data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                            >
                                <Field
                                    // value={value}
                                    // onChange={onChange}
                                    key={item?.name}
                                    objectName={objectName}
                                    contextObject={contextObject}
                                    auth={auth}
                                    formItem={true}
                                    data={data}
                                    item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                    isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                                />
                            </Form.Item>
                        )
                    })}
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                    {JSX(() => { // Хитовость трека
                        let data = undefined;
                        let locator = undefined;
                        let isChangedField = undefined;
                        let contextObject = undefined;
                        let funcStat = undefined;
                        let object = undefined;
                        let objectName = props?.name;
                        let item = {
                            "name": "KhitovostTreka",
                            "type": "uint",
                            "label": "Хитовость трека",
                            "validators": {
                                "required": false,
                                "min": null,
                                "max": null,
                                "pattern": null
                            },
                        }
                        return (
                            <Form.Item
                                style={{ width: "100%" }}
                                preserve={(item?.hidden) ? "true" : "false"}
                                hidden={item?.hidden}
                                key={item?.name}
                                name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                                label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                                rules={formItemRules(item)}
                                data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                            >
                                <Field
                                    // value={value}
                                    // onChange={onChange}
                                    key={item?.name}
                                    objectName={objectName}
                                    contextObject={contextObject}
                                    auth={auth}
                                    formItem={true}
                                    data={data}
                                    item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                    isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                                />
                            </Form.Item>
                        )
                    })}
                    {JSX(() => { // Сложность трека
                        let data = undefined;
                        let locator = undefined;
                        let isChangedField = undefined;
                        let contextObject = undefined;
                        let funcStat = undefined;
                        let object = undefined;
                        let objectName = props?.name;
                        let item = {
                            "name": "SlozhnostTreka",
                            "type": "uint",
                            "label": "Сложность трека",
                            "validators": {
                                "required": false,
                                "min": null,
                                "max": null,
                                "pattern": null
                            },
                        }
                        return (
                            <Form.Item
                                style={{ width: "100%" }}
                                preserve={(item?.hidden) ? "true" : "false"}
                                hidden={item?.hidden}
                                key={item?.name}
                                name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                                label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                                rules={formItemRules(item)}
                                data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                            >
                                <Field
                                    // value={value}
                                    // onChange={onChange}
                                    key={item?.name}
                                    objectName={objectName}
                                    contextObject={contextObject}
                                    auth={auth}
                                    formItem={true}
                                    data={data}
                                    item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                    isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                                />
                            </Form.Item>
                        )
                    })}
                </div>
                <Collapse ghost
                    style={{ backgroundColor: "aliceblue", borderRadius: "6px", margin: "10px 0" }}
                    items={[
                        {
                            key: '1',
                            label: 'Акценты и обыгрыши',
                            children: <div>
                                {JSX(() => { // Количество сбивок за полторы минуты
                                    let data = undefined;
                                    let locator = undefined;
                                    let isChangedField = undefined;
                                    let contextObject = undefined;
                                    let funcStat = undefined;
                                    let object = undefined;
                                    let objectName = props?.name;
                                    let item = {
                                        "name": "KolichestvoAktsentovZaPoltoriMinuti",
                                        "type": "uint",
                                        "label": "Количество сбивок за полторы минуты",
                                        "validators": {
                                            "required": false,
                                            "min": null,
                                            "max": null,
                                            "pattern": null
                                        },
                                    }
                                    return (
                                        <Form.Item
                                            preserve={(item?.hidden) ? "true" : "false"}
                                            hidden={item?.hidden}
                                            key={item?.name}
                                            name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                                            label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                                            rules={formItemRules(item)}
                                            data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                                        >
                                            <Field
                                                // value={value}
                                                // onChange={onChange}
                                                key={item?.name}
                                                objectName={objectName}
                                                contextObject={contextObject}
                                                auth={auth}
                                                formItem={true}
                                                data={data}
                                                item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                                isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                                            />
                                        </Form.Item>
                                    )
                                })}
                                {JSX(() => { // Количество сбивок за две минуты
                                    let data = undefined;
                                    let locator = undefined;
                                    let isChangedField = undefined;
                                    let contextObject = undefined;
                                    let funcStat = undefined;
                                    let object = undefined;
                                    let objectName = props?.name;
                                    let item = {
                                        "name": "KolichestvoAktsentovZaDveMinuti",
                                        "type": "uint",
                                        "label": "Количество сбивок за две минуты",
                                        "validators": {
                                            "required": false,
                                            "min": null,
                                            "max": null,
                                            "pattern": null
                                        },
                                    }
                                    return (
                                        <Form.Item
                                            preserve={(item?.hidden) ? "true" : "false"}
                                            hidden={item?.hidden}
                                            key={item?.name}
                                            name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                                            label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                                            rules={formItemRules(item)}
                                            data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                                        >
                                            <Field
                                                // value={value}
                                                // onChange={onChange}
                                                key={item?.name}
                                                objectName={objectName}
                                                contextObject={contextObject}
                                                auth={auth}
                                                formItem={true}
                                                data={data}
                                                item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                                isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                                            />
                                        </Form.Item>
                                    )
                                })}
                                {JSX(() => { // Кол-во смен ритмов бачаты
                                    let data = undefined;
                                    let locator = undefined;
                                    let isChangedField = undefined;
                                    let contextObject = undefined;
                                    let funcStat = undefined;
                                    let object = undefined;
                                    let objectName = props?.name;
                                    let item = {
                                        "name": "KolvoSmenRitmovBachati",
                                        "type": "uint",
                                        "label": "Кол-во смен ритмов бачаты",
                                        "validators": {
                                            "required": false,
                                            "min": null,
                                            "max": null,
                                            "pattern": null
                                        },
                                    }
                                    return (
                                        <Form.Item
                                            preserve={(item?.hidden) ? "true" : "false"}
                                            hidden={item?.hidden}
                                            key={item?.name}
                                            name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                                            label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                                            rules={formItemRules(item)}
                                            data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                                        >
                                            <Field
                                                // value={value}
                                                // onChange={onChange}
                                                key={item?.name}
                                                objectName={objectName}
                                                contextObject={contextObject}
                                                auth={auth}
                                                formItem={true}
                                                data={data}
                                                item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                                isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                                            />
                                        </Form.Item>
                                    )
                                })}
                                {JSX(() => { // Количество акцентов за две минуты
                                    let data = undefined;
                                    let locator = undefined;
                                    let isChangedField = undefined;
                                    let contextObject = undefined;
                                    let funcStat = undefined;
                                    let object = undefined;
                                    let objectName = props?.name;
                                    let item = {
                                        "name": "KolvoObigrishei",
                                        "type": "uint",
                                        "label": "Количество акцентов за две минуты",
                                        "validators": {
                                            "required": false,
                                            "min": null,
                                            "max": null,
                                            "pattern": null
                                        },
                                    }
                                    return (
                                        <Form.Item
                                            preserve={(item?.hidden) ? "true" : "false"}
                                            hidden={item?.hidden}
                                            key={item?.name}
                                            name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                                            label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                                            rules={formItemRules(item)}
                                            data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                                        >
                                            <Field
                                                // value={value}
                                                // onChange={onChange}
                                                key={item?.name}
                                                objectName={objectName}
                                                contextObject={contextObject}
                                                auth={auth}
                                                formItem={true}
                                                data={data}
                                                item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                                isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                                            />
                                        </Form.Item>
                                    )
                                })}
                            </div>,
                        }
                    ]} />

                <Tabs defaultActiveKey="Kommentarii">
                    <Tabs.TabPane tab={"Комментарий"} key={"Kommentarii"}>
                        {JSX(() => { // Комментарий
                            let data = undefined;
                            let locator = undefined;
                            let isChangedField = undefined;
                            let contextObject = undefined;
                            let funcStat = undefined;
                            let object = undefined;
                            let objectName = props?.name;
                            let item = {
                                // "hidden": true, //!!!!!!!!!!!!!
                                "name": "Kommentarii",
                                "type": "text",
                                // "label": "Комментарий",
                                "validators": {
                                    "required": false,
                                    "min": null,
                                    "max": 1000,
                                    "pattern": null
                                },
                            }
                            return (
                                <Form.Item
                                    preserve={(item?.hidden) ? "true" : "false"}
                                    hidden={item?.hidden}
                                    key={item?.name}
                                    name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                                    label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                                    rules={formItemRules(item)}
                                    data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                                >
                                    <Field
                                        // value={value}
                                        // onChange={onChange}
                                        key={item?.name}
                                        objectName={objectName}
                                        contextObject={contextObject}
                                        auth={auth}
                                        formItem={true}
                                        data={data}
                                        item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                        isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                                    />
                                </Form.Item>
                            )
                        })}
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={"Тема песни"} key={"TemaPesni"}>
                        {JSX(() => { // Тема песни
                            let data = undefined;
                            let locator = undefined;
                            let isChangedField = undefined;
                            let contextObject = undefined;
                            let funcStat = undefined;
                            let object = undefined;
                            let objectName = props?.name;
                            let item = {
                                // "hidden": true, //!!!!!!!!!!!!!
                                "name": "TemaPesni",
                                "type": "text",
                                // "label": "Тема песни",
                                "validators": {
                                    "required": false,
                                    "min": null,
                                    "max": 1000,
                                    "pattern": null
                                },
                            }
                            return (
                                <Form.Item
                                    preserve={(item?.hidden) ? "true" : "false"}
                                    hidden={item?.hidden}
                                    key={item?.name}
                                    name={(item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID"}
                                    label={(item.type !== "bool" && item.type !== "boolean") ? item?.label : undefined}
                                    rules={formItemRules(item)}
                                    data-locator={getLocator(props?.locator || objectName || "model", props?.object)}
                                >
                                    <Field
                                        // value={value}
                                        // onChange={onChange}
                                        key={item?.name}
                                        objectName={objectName}
                                        contextObject={contextObject}
                                        auth={auth}
                                        formItem={true}
                                        data={data}
                                        item={{ ...item, filterType: undefined, func: (props?.funcStat && props?.funcStat[item?.name?.toLowerCase()]) ? props?.funcStat[item?.name?.toLowerCase()] : {} }}
                                        isChanged={(isChangedField) ? isChangedField((item.type !== "object" && item.type !== "document") ? uncapitalize(item?.name) : uncapitalize(item?.name) + "ID") : undefined}
                                    />
                                </Form.Item>
                            )
                        })}
                    </Tabs.TabPane>
                </Tabs>

            </Form>
        </div>
        <div>
            {(object && object?.ID && links) && <div style={{ display: (links === "inline") ? "block" : "none" }}>
                <Tabs defaultActiveKey="sozdatelitreka">
                    <Tabs.TabPane data-locator={getLocator(props?.locator || "model-collection" + props?.name || "model-collection", props?.object)} tab={sozdatelitreka_e.label} key={sozdatelitreka_e?.name?.toLowerCase()}>
                        <CollectionByProperty auth={auth} item={sozdatelitreka_e} object={object}
                            // objectName={props?.name}
                            linksCompareFunction={props?.linksCompareFunction}
                            linksModelActions={props?.links}
                            scheme={props?.scheme}
                            queryDetail={props?.queryDetail}
                            modelActions={props?.modelActions}
                            collectionActions={props?.collectionActions}
                        />
                    </Tabs.TabPane>
                </Tabs>
            </div>}
        </div>

    </div>)
}